import React from "react";

/** כרטיס פנימי — אותם טוקנים כמו .fw-review-card */
export default function FWCard({ children, className = "", as: Comp = "div", ...rest }) {
  return (
    <Comp className={`fw-ui-kit-card${className ? ` ${className}` : ""}`.trim()} {...rest}>
      {children}
    </Comp>
  );
}
